import { number, bool, string } from 'prop-types';
import { compose } from '../../../../../utils/fp';
import { addCurrency, formatPrice } from '../../utils/helperFuncs';
import * as styles from './ProductQuantity.module.css';

const ProductQuantity = ({
  primaryQuantity,
  additionalQuantity,
  extraChoicePrice,
  premiumPrice = null,
}) => {
  const priceWithCurrency = compose(addCurrency, formatPrice);
  const getChoiceLabel = () => {
    if (premiumPrice)
      return `${primaryQuantity} x Luxe Choice - ${priceWithCurrency(
        primaryQuantity * premiumPrice,
      )}`;

    let label = '';

    if (primaryQuantity) {
      label += `${primaryQuantity} x Primary Choice`;
    }

    if (primaryQuantity && additionalQuantity) {
      label += '<br />';
    }

    if (additionalQuantity) {
      label += `${additionalQuantity} x Additional - ${priceWithCurrency(
        additionalQuantity * extraChoicePrice,
      )}`;
    }

    return label;
  };

  return (
    <p dangerouslySetInnerHTML={{ __html: getChoiceLabel() }} className={styles.productQuantity} />
  );
};

ProductQuantity.propTypes = {
  primaryQuantity: number.isRequired,
  additionalQuantity: number.isRequired,
  extraChoicePrice: number.isRequired,
  premiumPrice: number,
  autoAssigned: bool.isRequired,
  sku: string.isRequired,
};

export default ProductQuantity;
